module.exports = __webpack_public_path__ + "static/media/logo-100os.a7e2b271.svg";